import template from './households.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    expenses: '<',
    ticketClientTypes: '<',
    contacts: '<',
    income: '<',
    assets: '<',
    homeLoanSecurities: '<',
    workflow: '<',
    owner: '<',
    idTicket: '<',
    isTicketSettled: '<',
    isContactExpenses: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdMedia, $mdUtil, helperService, householdsService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.activeTab = 0;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().cca2;
        ctrl.expenses = ctrl.expenses || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.contacts = _.filter(ctrl.contacts || [], (c) => !c.isCompany);
        ctrl.income = ctrl.income || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.changedData = ctrl.changedData || '';
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isContactExpenses = ctrl.isContactExpenses || false;
        ctrl.removeNonexistentContacts();
        ctrl.isReady = true;
      };

      ctrl.removeNonexistentContacts = () => {
        let hasDiff = false;
        const idContacts = _.map(ctrl.contacts, 'id');
        const filteredExpenses = _.filter(ctrl.expenses, (e) => e?.id);
        const len = filteredExpenses?.length || 0;
        for (let i = 0; i < len; i += 1) {
          const diff = _.difference(filteredExpenses[i]?.idContacts, idContacts);
          if (diff?.length) {
            const dLen = diff.length;
            for (let d = 0; d < dLen; d += 1) {
              filteredExpenses[i].idContacts.splice(
                filteredExpenses[i]?.idContacts?.indexOf(diff[d]),
                1
              );
              if (!hasDiff) {
                hasDiff = true;
              }
            }
          }
        }
        if (hasDiff) {
          ctrl.saveExpenses();
        }
      };

      ctrl.canAddHousehold = () => {
        const idContacts = _.map(ctrl.contacts, 'id');
        const householdsIdContacts = _.flatten(_.compact(_.map(ctrl.expenses, 'idContacts')));
        return idContacts?.length !== householdsIdContacts?.length;
      };

      ctrl.addHousehold = () => {
        householdsService.addHousehold({ expenses: ctrl.expenses });
        if (
          ctrl.isContactExpenses &&
          !ctrl.expenses[0]?.idContacts?.length &&
          ctrl.contacts[0]?.id
        ) {
          ctrl.expenses[0].idContacts.push(ctrl.contacts[0].id);
          // ctrl.toggleTab({ index: ctrl.expenses?.length - 1, tab: ctrl.activeTab });
          ctrl.saveExpenses();
        }
        if (ctrl.expenses?.length > 1) {
          ctrl.toggleTab({ index: ctrl.expenses?.length - 1, tab: ctrl.activeTab });
        }
      };

      ctrl.removeHousehold = ({ index }) => {
        const item = ctrl.expenses[index];
        const tabName = ctrl.getTabTitle({ household: ctrl.expenses[index] });
        householdsService
          .removeHousehold({ collection: ctrl.expenses, item, tabName })
          .then((result) => {
            if (result) {
              ctrl.toggleTab({ index: ctrl.expenses?.length - 1, tab: ctrl.activeTab });
              ctrl.saveExpenses();
            }
          });
      };

      ctrl.toggleTab = ({ index, tab }) => {
        ctrl.activeTab = tab === index ? undefined : index;
      };

      ctrl.getTabTitle = ({ household }) => {
        let title = '-';
        if (household?.id) {
          title = household?.idContacts?.length
            ? `Household of ${_.map(
                _.filter(ctrl.contacts, (c) => household?.idContacts.indexOf(c?.id) > -1),
                (h) => h?.getName()
              ).join(' and ')}`
            : 'Please choose contact(s)';
        } else {
          title = 'Archived';
        }
        return title;
      };

      ctrl.changeContacts = ({ household }) => {
        const hhd = household;
        if (hhd?.idContacts?.length > 2) {
          hhd.idContacts = ctrl.prevModel;
        } else {
          ctrl.prevModel = hhd?.idContacts;
        }
        ctrl.saveExpenses();
      };

      ctrl.isContactSelected = ({ idContact, idContacts }) => {
        const idExpensesContacts = _.flatten(_.compact(_.map(ctrl.expenses, 'idContacts')));
        const idHouseholdContacts = _.difference(idExpensesContacts, idContacts);
        if (idHouseholdContacts?.indexOf(idContact) === -1) {
          return false;
        }
        return true;
      };

      ctrl.saveHousehold = (data) => {
        if (data && !_.isEmpty(data) && data?.idx > -1) {
          ctrl.expenses[data.idx] = data.household;
          ctrl.saveExpenses();
        }
      };

      ctrl.saveExpenses = () => {
        const data = {
          expenses: ctrl.expenses,
          tCD: 'expenses'
        };
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
